/**
 *
 * IconButton
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { lightBlack } from 'styles/colors';

const StyledButton = styled(Button)`
  &.btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    font-size: 15px;
    &.btn-fab {
      border-radius: 50%;
      &.btn-lg {
        width: 40px;
        height: 40px;
        font-size: 18px;
      }
    }
    @media (min-width: 360px) {
      width: 40px;
      height: 40px;
      font-size: 18px;
      &.btn-fab {
        &.btn-lg {
          width: 48px;
          height: 48px;
          font-size: 21px;
        }
      }
    }
    @media (min-width: 480) {
      width: 48px;
      height: 48px;
      font-size: 21px;
      &.btn-fab {
        &.btn-lg {
          width: 56px;
          height: 56px;
          font-size: 24px;
        }
      }
    }
    &.btn-default {
      color: ${lightBlack};
    }
  }
`;

function IconButton(props) {
  const { icon, ...rest } = props;
  return (
    <StyledButton {...rest}>
      <FontAwesomeIcon icon={icon} fixedWidth />
    </StyledButton>
  );
}

IconButton.propTypes = {
  icon: PropTypes.string,
};

export default IconButton;
